<template>
    <main class="main  animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
       
      <div class="embed-responsive embed-responsive-16by9" v-if="showContentFromNotion">                
        <iframe 
            src="https://adaptive-nectarine-029.notion.site/ebd/Onboarding-Booker-2c16c45e9568805390c5cca5b876b077" 
            width="100%" 
            height="600" 
            frameborder="0" 
            allowfullscreen />
             <!-- https://adaptive-nectarine-029.notion.site/ebd/1c16c45e956880e19da5f3331803cf42 -->
      </div>

      <template v-else>
        <div class="row m-4" >    

              <div class="col-4">
                  <p class="mb-2">Introduction sur la mission du Booker</p>
                  <div class="embed-responsive embed-responsive-16by9">                
                      <VideoToolToy
                      :url="'https://www.loom.com/embed/97f3a8b3743a4a1d82286e69ae2abea3?sid=1086669b-2f42-498a-a426-3886bff8062d'"
                      :autoplay="false"
                      />
                  </div>                            
              </div>            
              
              <div class="col-4">
                  <p class="mb-2">Consultez notre base de connaissance</p>
                  <a href="https://adaptive-nectarine-029.notion.site/19e6c45e95688030ae41e1c9a02f2c91?v=19e6c45e95688077bf0c000cd12252a6" target="_blank">
                      <img class="img-fluid" src="@/assets/images/booker/visual_knowledge_base.png" alt="" srcset="">
                  </a>
              </div>

              <div class="col-4">
                  <p class="mb-2">Vous vous sentez prêt à débuter votre mission ?</p>
                  <a href="https://meetings-eu1.hubspot.com/theo-criscione?uuid=2b72c1cc-eb6b-4641-8737-710404cdc787" target="_blank">
                      <img  class="img-fluid" src="@/assets/images/booker/booker_meet.png" alt="" srcset="">
                  </a>                
              </div>
        </div>
        <div class="row m-4">
          <div class="col-12">
              <h5>Les différents cas à traiter par les Bookers.</h5>
          </div>
        </div>
        <div class="row m-4">
          <div class="col-4 my-2" v-for="(item, i) of bookerCases" :key="i">

              <p class="mb-2">{{item.title}}</p>

              <template v-if="item.isVideo">                    
                  <div class="embed-responsive embed-responsive-16by9">                                    
                      <VideoToolToy
                      :url="item.url"
                      :autoplay="false"
                      />
                  </div>                            
              </template>
              <template v-else>
              </template>
          </div>   
        </div>
      </template>
    </main>    
</template>

<script>
import { mapState } from "vuex";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";

export default {
  name: 'BookerOnboarding',
  components: {
    VideoToolToy
  },
  props: {
  },
  data() {
    return {
      showContentFromNotion: true,
      bookerCases: [
        {
            title: '1 Reprogrammation',
            isVideo: true,
            url: "https://www.loom.com/embed/2146ad2e5099486f8c4806e15c8703e2"
        },
        {
            title: '2 urgent',
            isVideo: true,
            url: "https://www.loom.com/embed/2146ad2e5099486f8c4806e15c8703e2"
        },
        {
            title: '3 Positive',
            isVideo: true,
            url: "https://www.loom.com/embed/2146ad2e5099486f8c4806e15c8703e2"
        },
        {
            title: '4 Calendar Inspection',
            isVideo: true,
            url: "https://www.loom.com/embed/97f3a8b3743a4a1d82286e69ae2abea3?sid=1086669b-2f42-498a-a426-3886bff8062d"
        },
        {
            title: '5 Introduction',
            isVideo: true,
            url: "https://www.loom.com/embed/97f3a8b3743a4a1d82286e69ae2abea3?sid=1086669b-2f42-498a-a426-3886bff8062d"
        },
        {
            title: '6 Cold',
            isVideo: true,
            url: "https://www.loom.com/embed/97f3a8b3743a4a1d82286e69ae2abea3?sid=1086669b-2f42-498a-a426-3886bff8062d"
        },    
      ],
    };
  },
  computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
    }),
  },
  watch: {
  },
  methods: {
    exampleMethod() {
      console.log('Example method');
    }
  },
  created() {
    console.log('BookerOnboarding created');
  },
  mounted() {
    console.log('BookerOnboarding mounted');
  }
};
</script>

<style scoped>
</style>